import verifyAccount from './verifyAccount';

export default { ...verifyAccount };
